import {Box, Button, createStyles, Text} from '@mantine/core';
import React from 'react';

import {trackEvent} from 'analytics/Analytics';
import {HOMEPAGE_ANALYTICS_ACTIONS} from 'constants/analytics-products/HomepageAnalyticsConstants';
import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import preferences from 'Preferences';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import * as SidepanelActions from '../SidepanelActions';
import HomepageBanner from './HomepageBanner';
import {HomepagePreferences} from './HomepageConstants';

const useStyles = createStyles((theme) => ({
  emoji: {
    fontSize: '20px',
    margin: '0 16px',
    verticalAlign: 'sub',
  },
  text: {
    fontSize: theme.fontSizes.md,
  },
  title: {
    fontWeight: theme.other.fontWeights.semibold,
  },
  returnLink: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  xsMarginRight: {
    marginRight: theme.spacing.xs,
  },
  feedbackButton: {
    // it's a link, so this is a reset
    '&:hover': {
      color: 'unset',
      textDecoration: 'unset',
    },
  },
}));

export default function HomepagePreviewBanner(): JSX.Element {
  const {classes} = useStyles();

  const {navShowHomepageUserOptOut} = useRolloutFlags();

  const handleReturnToLegacyHomepage = (): void => {
    trackEvent(HOMEPAGE_ANALYTICS_ACTIONS.OPTED_OUT);
    SidepanelActions.collapse();
    preferences.set(HomepagePreferences.SHOW_NEW_HOMEPAGE, false);
  };

  return (
    <HomepageBanner
      color="blue"
      rightSection={
        <Button
          // eslint-disable-next-line no-restricted-syntax -- no custom variant matches the design, yet
          variant="default"
          color="gray"
          component="a"
          radius="md"
          href="https://airtable.com/appm4pQf61j9VhmNW/pagYyCcrOgvn9H1K3/form"
          leftIcon={<BenchlingIcon icon="message" className={classes.xsMarginRight} />}
          rel="noopener noreferrer"
          size="md"
          target="_blank"
          className={classes.feedbackButton}
        >
          Share feedback
        </Button>
      }
    >
      <Box className={classes.text}>
        <Text className={classes.emoji} span={true} aria-hidden={true}>
          🎉
        </Text>
        <Text className={classes.title} span={true}>
          Welcome to your new homepage!
        </Text>{' '}
        {navShowHomepageUserOptOut && (
          <Text span={true}>
            You can still{' '}
            <Text
              span={true}
              className={classes.returnLink}
              {...getActionButtonRoleProps({onPress: handleReturnToLegacyHomepage})}
            >
              return to the legacy homepage
            </Text>{' '}
            for a limited time.
          </Text>
        )}
      </Box>
    </HomepageBanner>
  );
}
